<template>
    <div class="wrapper" :class="$route.meta.headerClass">
        <the-header />
        <main class="page">
            <router-view />
        </main>
        <the-footer />
        <cookie-popup />
        <subscribe v-if="isSubscribe && $route.meta.subscribe" :title="`Забирай подарок\n от Тюбетей!`" :message="`Подпишись, чтобы получить\n бесплатный туристический гайд\n и 100 бонусов в подарок`" @close="subscribeClose()" />
        <iftar-combo v-if="isIftarCombo" :title="`Закажите ифтар-комбо с доставкой`" message="Ифтар — особенный вечер, наполненный теплом и благодарностью" @close="IftarComboModalClose()" />
        <ash-balance v-if="isAshBalance" :title="displayMobile ? `Когда ты последний раз\n ел без телефона?` : `Когда ты последний раз ел\n без телефона?`" :message="displayMobile ? `Пройди тест на Эш-Аш баланс и получи 100 Т-коинов` : `Проверь свой Эш-Аш баланс\n и получи 100 Т-коинов`" @close="isAshBalance = false" />
    </div>
</template>

<script>
import TheHeader from "./components/TheHeader.vue";
import TheFooter from "./components/TheFooter.vue";
import CookiePopup from "@/components/popups/CookiePopup.vue";
import Subscribe from "./components/popups/Subscribe.vue";
import IftarCombo from "./components/popups/IftarCombo.vue";
import AshBalance from "./components/popups/AshBalance.vue";
export default {
    components: { TheHeader, TheFooter, CookiePopup, Subscribe, IftarCombo, AshBalance },
    data() {
        return {
            isSubscribe: false,
            subscribe: localStorage.getItem("subscribe") ?? false,
            min: 2,
            isIftarCombo: false,
            isAshBalance: false,
        };
    },
    mounted() {
        this.subscribeModal();
        //this.IftarComboModal();
    },
    methods: {
        subscribeClose() {
            this.isSubscribe = false;
            localStorage.setItem("subscribe", true);
        },
        subscribeModal() {
            if (this.subscribe) {
                this.isSubscribe = false;
            } else {
                setTimeout(() => {
                    this.isSubscribe = true;
                }, this.min * 60 * 1000);
            }
        },
        IftarComboModalClose() {
            this.isIftarCombo = false;
            //this.isAshBalance = true;
            localStorage.setItem("close_modals", true);
        },
        IftarComboModal() {
            if (!localStorage.getItem("close_modals")) {
                setTimeout(() => {
                    //this.isAshBalance = false;
                    this.isIftarCombo = true;
                }, 15 * 1000);
            }
        },
    },
    watch: {
        $route() {
            this.subscribeModal();
            //this.IftarComboModal();
        },
    },
    computed: {
        displayMobile() {
            return window.innerWidth <= 768;
        },
    },
};
</script>
